// extracted by mini-css-extract-plugin
export default {"mainCard":"Category_mainCard__8LZmu","mainImg":"Category_mainImg__5eyTw","imgTitle":"Category_imgTitle__zTAJz","checkout_form":"Category_checkout_form__jeqUp"};